<div class="p-fluid p-grid">
  <div class="p-col-12">
    <p-card header="Pessoa: {{pessoa?.nome}}">
      <div class="p-fluid">
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
          <div class="p-col-12 p-md-10">{{pessoa.id}}</div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Origem Id:</label>
          <div class="p-col-12 p-md-10">{{pessoa.fonteDados?.nome}} - {{pessoa.origemId}}</div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome: </label>
          <div class="p-col-12 p-md-10" title="Nome fonético: {{pessoa.nomeFonetico}}">{{pessoa.nome}}</div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Tipo: </label>
          <div class="p-col-12 p-md-10" *ngIf="pessoa.tipo === 'FISICA'" class="badge badge-blue m-l-8">Física</div>
          <div class="p-col-12 p-md-10" *ngIf="pessoa.tipo === 'JURIDICA'" class="badge badge-success m-l-8">Jurídica</div>
        </div>
        <div class="p-field p-grid">
          <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Cadastro da Receita:</label>
          <div class="p-col-12 p-md-10">
            <span *ngIf="pessoa.cadastroReceita !== undefined">{{pessoa.cadastroReceita}}</span>
            <span *ngIf="pessoa.cadastroReceita === undefined">Inconsistente</span>
          </div>
        </div>
        <ng-container *ngIf="pessoa.tipo === 'FISICA'">
          <div class="p-field p-grid">
            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Sexo:</label>
            <div class="p-col-12 p-md-10">{{pessoa.fisica.sexo}}</div>
          </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nascimento:</label>
              <div class="p-col-12 p-md-10">{{pessoa.fisica.dataNascimento | date: 'dd/MM/yyyy'}}</div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Obito:</label>
              <div class="p-col-12 p-md-10">{{pessoa.fisica.dataObito | date: 'dd/MM/yyyy'}}</div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Naturalidade:</label>
              <div class="p-col-12 p-md-10">
                <span *ngIf="pessoa.fisica.naturalidade != null">
                  <span *ngIf="pessoa.fisica.naturalidade.id != -1">
                    <a [routerLink]="['/localidade/visualizar/', pessoa.fisica.naturalidade.id]" title="Visualizar a localidade">{{pessoa.fisica.naturalidade.nome}}</a>
                    - <a [routerLink]="['/unidadeFederativa/visualizar/', pessoa.fisica.naturalidade.unidadeFederativa.id]" title="Visualizar a unidade federativa">{{pessoa.fisica.naturalidade.unidadeFederativa.sigla}}</a>
                  </span>
                  <span *ngIf="pessoa.fisica.naturalidade.id == -1">Inconsistente</span>
                </span>
              </div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nacionalidade:</label>
              <div class="p-col-12 p-md-10">
                <span *ngIf="pessoa.fisica.nacionalidade != null">
                  <span *ngIf="pessoa.fisica.nacionalidade.id != -1">
                    <a [routerLink]="['/pais/visualizar/', pessoa.fisica.nacionalidade.id]" title="Visualizar o país">{{pessoa.fisica.nacionalidade.nome}}</a>
                  </span>
                  <span *ngIf="pessoa.fisica.nacionalidade.id == -1">Inconsistente</span>
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="pessoa.tipo === 'JURIDICA'">
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Nome fantasia:</label>
              <div class="p-col-12 p-md-10">{{pessoa.juridica.nomeFantasia}}</div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Abertura:</label>
              <div class="p-col-12 p-md-10">{{pessoa.juridica.dataAbertura | date: 'dd/MM/yyyy'}}</div>
            </div>
            <div class="p-field p-grid">
              <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Encerramento:</label>
              <div class="p-col-12 p-md-10">{{pessoa.juridica.dataEncerramento | date: 'dd/MM/yyyy'}}</div>
            </div>
          </ng-container>
        </div>

        <p-tabView [(activeIndex)]="tabViewIndex" (onChange)="onChangeTabView()">
          <p-tabPanel header="Documentos" leftIcon="pi pi-id-card">

            <div class="p-fluid p-grid">
              <div class="p-col-12 p-lg-12">
                <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsDocumentos && dsDocumentos.restricoes">
                  <div class="p-fluid p-formgrid p-grid" (keyup)="dsDocumentos.onEnterPesquisar($event)">
                    <div class="p-field p-col-12 p-md-3">
                      <m-restricao-number label="Id" [restricao]="dsDocumentos.restricoes.atributo('id')"></m-restricao-number>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <m-restricao-string label="Origem Id" [restricao]="dsDocumentos.restricoes.atributo('origemId')"></m-restricao-string>
                    </div>
                    <div class="p-field p-col-3">
                      <label class="m-l-8 m-b-1">Tipo:</label>
                      <p-dropdown
                        placeholder="Selecione..." [options]="pessoaDocumentoTipoItens"
                        [(ngModel)]="dsDocumentos.restricoes.atributo('tipo').valor"
                        class="p-dropdown-p"
                        filter="true">
                      </p-dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <m-restricao-string label="Número" [restricao]="dsDocumentos.restricoes.atributo('numero')"></m-restricao-string>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                      <m-restricao-string label="Nome" [restricao]="dsDocumentos.restricoes.atributo('nome')"></m-restricao-string>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                      <m-restricao-string label="Emissão" [restricao]="dsDocumentos.restricoes.atributo('emissor')"></m-restricao-string>
                    </div>
                  </div>
                  <ng-template pTemplate="footer">
                    <div class="p-fluid p-grid" style="padding-top: 1rem;">
                      <div class="p-field p-col-6">
                        <button pButton label="Pesquisar" (click)="dsDocumentos.pesquisar()"></button>
                      </div>
                      <div class="p-field p-col-6">
                        <button pButton class="p-button-secondary" label="Limpar" (click)="dsDocumentos.limpar()"></button>
                      </div>
                    </div>
                  </ng-template>
                </p-panel>
              </div>
            </div>

            <p-table
              *ngIf="dsDocumentos !== undefined"
              [totalRecords]="dsDocumentos.total"
              [value]="dsDocumentos.entidades"
              (onLazyLoad)="dsDocumentos.carregar($event)"
              [(rows)]="dsDocumentos.registros"
              [paginator]="true"
              currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
              [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,25,50,100]"
              [rows]="30"
              paginatorPosition = "bottom"
              [lazy]="true"
              responsive="true"
              responsiveLayout="scroll"
              styleClass="p-datatable-striped">
              <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;"> Id <p-sortIcon field="id"></p-sortIcon></th>
                <th pSortableColumn="origemId" style="width: 160px">Origem Id.<p-sortIcon field="origemId"></p-sortIcon></th>
                <th class="p-text-break" style="width: 18%">Tipo</th>
                <th class="p-text-break">Número</th>
                <th class="p-text-break">Nome</th>
                <th class="p-text-break">Emissão</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-documento>
              <tr>
                <td>{{documento.id}}</td>
                <td>{{documento.origemId}}</td>
                <td>{{documento.tipo}}</td>
                <td>
                  <div [class.excluido]="documento.dataExclusao != null">{{documento.numero}}</div>
                  <div *ngIf="documento.dataExclusao !== null" class="exclusao-data">
                    Excluído em: {{documento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
                  </div>
                </td>
                <td>{{documento.nome}}</td>
                <td>
                  {{documento.emissor}}
                  <span *ngIf="documento.emissorEstado !== null"> - {{documento.emissorEstado}}</span>
                  <div *ngIf="documento.dataEmissao !== null" style="font-size: 0.8em; font-style: italic;">
                    Emitido em: {{documento.dataEmissao | date: 'dd/MM/yyyy'}}
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="6">Nenhum documento cadastrado</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>

        <p-tabPanel header="Endereços" leftIcon="pi pi-map-marker">
          <div class="p-fluid p-grid">
            <div class="p-col-12 p-lg-12">
              <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsEndereco && dsEndereco.restricoes">
                <div class="p-fluid p-formgrid p-grid" (keyup)="dsEndereco.onEnterPesquisar($event)">
                  <div class="p-field p-col-12 p-md-3">
                    <m-restricao-number label="Id" [restricao]="dsEndereco.restricoes.atributo('id')"></m-restricao-number>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <m-restricao-string label="Origem Id" [restricao]="dsEndereco.restricoes.atributo('origemId')"></m-restricao-string>
                  </div>
                  <div class="p-field p-col-3">
                    <m-restricao-string label="CEP"  [restricao]="dsEndereco.restricoes.atributo('endereco.cep.numero')"></m-restricao-string>
                  </div>
                  <div class="p-field p-col-6">
                    <m-restricao-string label="Endereço"  [restricao]="dsEndereco.restricoes.atributo('endereco.logradouro')"></m-restricao-string>
                  </div>
                  <div class="p-field p-col-3">
                    <m-restricao-string label="Localidade"  [restricao]="dsEndereco.restricoes.atributo('endereco.localidadeNome')"></m-restricao-string>
                  </div>
                </div>
                <ng-template pTemplate="footer">
                  <div class="p-fluid p-grid" style="padding-top: 1rem;">
                    <div class="p-field p-col-6">
                      <button pButton label="Pesquisar" (click)="dsEndereco.pesquisar()"></button>
                    </div>
                    <div class="p-field p-col-6">
                      <button pButton class="p-button-secondary" label="Limpar" (click)="dsEndereco.limpar()"></button>
                    </div>
                  </div>
                </ng-template>
              </p-panel>
            </div>
          </div>
          <p-table
            *ngIf="dsEndereco !== undefined"
            [value]="dsEndereco.entidades"
            [totalRecords]="dsEndereco.total"
            (onLazyLoad)="dsEndereco.carregar($event)"
            [(rows)]="dsEndereco.registros"
            [lazy]="true"
            [paginator]="true"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[30,50,100]"
            [rows]="30"
            paginatorPosition = "bottom"
            responsive="true"
            sortMode="multiple"
            styleClass="p-datatable-striped"
            responsiveLayout="scroll"
            emptyMessage="Nenhum registro encontrado">
            <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;"> Id <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="origemId" style="width: 160px">Origem Id.<p-sortIcon field="origemId"></p-sortIcon></th>
              <th>Endereço</th>
              <th pSortableColumn="endereco.cep.numero" style="width: 18%"> CEP <p-sortIcon field="endereco.cep.numero"></p-sortIcon></th>
              <th pSortableColumn="endereco.localidadeNome"> Localidade <p-sortIcon field="endereco.localidadeNome"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-endereco>
            <tr>
              <td>{{endereco.id}}</td>
              <td>{{endereco.origemId}}</td>
              <td>
                <div [class.excluido]="endereco.dataExclusao != null">
                  {{endereco.endereco.logradouro}} <span *ngIf="endereco.endereco.numero != null">, {{endereco.endereco.numero}}</span><br/>
                  {{endereco.endereco.bairro}}
                  <div *ngIf="endereco.endereco.complemento != null">{{endereco.endereco.complemento}}</div>
                </div>
                <div *ngIf="endereco.dataExclusao !== null" class="exclusao-data">
                  Excluído em: {{endereco.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
                </div>
              </td>
              <td>
                <span *ngIf="endereco.endereco.cep != null && endereco.endereco.cep.id !== -1">
                  <a [routerLink]="['/cep/visualizar/', endereco.endereco.cep.id]" title="Visualizar o cep">{{endereco.endereco.cep.numero}}</a>
                </span>
                <span *ngIf="endereco.endereco.cep != null && endereco.endereco.cep.id === -1 || endereco.endereco.cep == null">
                  {{endereco.endereco.cepNumero}}
                </span>
              </td>
              <td>
                <span *ngIf="endereco.endereco.localidade != null">
                  <a [routerLink]="['/localidade/visualizar/', endereco.endereco.localidade.id]" title="Visualizar a localidade">{{endereco.endereco.localidade.nome}}</a>
                </span>

                <span *ngIf="endereco.endereco.localidade == null">
                  {{endereco.endereco.localidadeNome}}
                </span>

                <span *ngIf="endereco.endereco.unidadeFederativa != null">
                  - <a [routerLink]="['/unidadeFederativa/visualizar/', endereco.endereco.unidadeFederativa.id]" title="Visualizar a unidade federativa">{{endereco.endereco.unidadeFederativa.sigla}}</a>
                </span>

                <span *ngIf="endereco.endereco.pais != null">
                  - <a [routerLink]="['/pais/visualizar/', endereco.endereco.pais.id]" title="Visualizar o país">{{endereco.endereco.pais.nome}}</a>
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="5"> Nenhum endereço cadastrado</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Outros nomes" leftIcon="pi pi-user-plus">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsOutrosNomes && dsOutrosNomes.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsOutrosNomes.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsOutrosNomes.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsOutrosNomes.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Nome"  [restricao]="dsOutrosNomes.restricoes.atributo('nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-3">
                  <label class="m-l-8">Tipo:</label>
                  <p-dropdown
                    placeholder="Selecione..." [options]="pessoaOutroNomeTipoItens"
                    [(ngModel)]="dsOutrosNomes.restricoes.atributo('tipo').valor"
                    class="p-dropdown-p"
                    filter="true">
                  </p-dropdown>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsOutrosNomes.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsOutrosNomes.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>

        <p-table
          *ngIf="dsOutrosNomes !== undefined"
          [totalRecords]="dsOutrosNomes.total"
          [value]="dsOutrosNomes.entidades"
          (onLazyLoad)="dsOutrosNomes.carregar($event)"
          [(rows)]="dsOutrosNomes.registros"
          [lazy]="true"
          [paginator]="true"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[30,50,100]"
          [rows]="30"
          paginatorPosition = "bottom"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;"> Id <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="origemId" style="width: 160px">Origem Id.<p-sortIcon field="origemId"></p-sortIcon></th>
              <th  pSortableColumn="tipo" style="width: 18%">Tipo <p-sortIcon field="tipo"></p-sortIcon></th>
              <th>Nome</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-outroNome>
            <tr>
              <td>{{outroNome.id}}</td>
              <td>{{outroNome.origemId}}</td>
              <td>{{outroNome.tipo | dominio:'getPessoaOutroNomeTipo'}}</td>
              <td>
                <div [class.excluido]="outroNome.dataExclusao != null">{{outroNome.nome}}</div>
                <div *ngIf="outroNome.dataExclusao !== null" class="exclusao-data">
                  Excluído em: {{outroNome.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="4">Nenhum outro nome cadastrado</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel header="Relacionamentos" leftIcon="pi pi-globe">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsRelacionamentos && dsRelacionamentos.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsRelacionamentos.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsRelacionamentos.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsRelacionamentos.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Pessoa Relacionada"  [restricao]="dsRelacionamentos.restricoes.atributo('relacionada.nome')"></m-restricao-string>
                </div>
                <div class="p-field p-col-3">
                  <label class="m-l-8">Tipo:</label>
                  <p-dropdown
                    placeholder="Selecione..." [options]="pessoaRelacionamentosTipoItens"
                    [(ngModel)]="dsRelacionamentos.restricoes.atributo('tipo').valor"
                    class="p-dropdown-p"
                    filter="true">
                  </p-dropdown>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsRelacionamentos.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsRelacionamentos.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>

        <p-table
          [value]="pessoa.relacionamentos"
          *ngIf="dsRelacionamentos !== undefined"
          [totalRecords]="dsRelacionamentos.total"
          [value]="dsRelacionamentos.entidades"
          (onLazyLoad)="dsRelacionamentos.carregar($event)"
          [(rows)]="dsRelacionamentos.registros"
          [lazy]="true"
          [paginator]="true"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,25,50,100]"
          [rows]="10"
          paginatorPosition = "bottom"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped"
          responsive="true"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 15%">Id</th>
              <th style="width: 20%">Origem Id.</th>
              <th style="width: 15%">Tipo</th>
              <th>Pessoa relacionada</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-relacionamento>
            <tr>
              <td>{{relacionamento.id}}</td>
              <td>{{relacionamento.origemId}}</td>
              <td>{{relacionamento.tipo | dominio:'getPessoaRelacionamentoTipo'}}</td>
              <td>
                <div [class.excluido]="relacionamento.dataExclusao != null">
                  <a [routerLink]="['/pessoa/', relacionamento.relacionada.id]" title="Visualizar a pessoa">{{relacionamento.relacionada.nome}}</a>
                </div>
                <div *ngIf="relacionamento.dataExclusao !== null" class="exclusao-data">
                  Excluído em: {{relacionamento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="4">Nenhum relacionamento cadastrado</td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <p-tabPanel *ngIf="pessoa.tipo === 'FISICA'" header="Genitores" leftIcon="pi pi-users">
        <div class="p-fluid p-grid">
          <div class="p-col-12 p-lg-12">
            <p-panel header="Filtros"  [toggleable]="true" [collapsed]="true" *ngIf="dsGenitores && dsGenitores.restricoes">
              <div class="p-fluid p-formgrid p-grid" (keyup)="dsGenitores.onEnterPesquisar($event)">
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-number label="Id" [restricao]="dsGenitores.restricoes.atributo('id')"></m-restricao-number>
                </div>
                <div class="p-field p-col-12 p-md-3">
                  <m-restricao-string label="Origem Id" [restricao]="dsGenitores.restricoes.atributo('origemId')"></m-restricao-string>
                </div>
                <div class="p-field p-col-6">
                  <m-restricao-string label="Nome"  [restricao]="dsGenitores.restricoes.atributo('nome')"></m-restricao-string>
                </div>
              </div>
              <ng-template pTemplate="footer">
                <div class="p-fluid p-grid" style="padding-top: 1rem;">
                  <div class="p-field p-col-6">
                    <button pButton label="Pesquisar" (click)="dsGenitores.pesquisar()"></button>
                  </div>
                  <div class="p-field p-col-6">
                    <button pButton class="p-button-secondary" label="Limpar" (click)="dsGenitores.limpar()"></button>
                  </div>
                </div>
              </ng-template>
            </p-panel>
          </div>
        </div>
        <p-table
          *ngIf="dsGenitores !== undefined"
          [totalRecords]="dsGenitores.total"
          [value]="dsGenitores.entidades"
          [totalRecords]="dsGenitores.total"
          [value]="dsGenitores.entidades"
          (onLazyLoad)="dsGenitores.carregar($event)"
          [(rows)]="dsGenitores.registros"
          [lazy]="true"
          [paginator]="true"
          currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,25,50,100]"
          [rows]="10"
          paginatorPosition = "bottom"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped"
          responsive="true"
          responsiveLayout="scroll"
          styleClass="p-datatable-striped">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id" class="p-text-center"  style="width: 8rem;"> Id <p-sortIcon field="id"></p-sortIcon></th>
              <th pSortableColumn="origemId" style="width: 160px">Origem Id.<p-sortIcon field="origemId"></p-sortIcon></th>
              <th>Nome</th>
              <th pSortableColumn="sexo" style="width: 160px">Sexo<p-sortIcon field="sexo"></p-sortIcon></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-genitor>
            <tr>
              <td>{{genitor.id}}</td>
              <td>{{genitor.origemId}}</td>
              <td>
                <div [class.excluido]="genitor.dataExclusao != null">
                  {{genitor.nome}}
                </div>
                <div *ngIf="genitor.dataExclusao != null" class="exclusao-data">
                  Excluído em: {{genitor.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}
                </div>
              </td>
              <td>{{genitor.sexo}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="4">Nenhum genitor cadastrado</td>
            </tr>
          </ng-template>
        </p-table>
        </p-tabPanel>

        <p-tabPanel header="Telefones" leftIcon="pi pi-phone" >
            <app-pessoa-telefone [pessoa]="pessoa">
            </app-pessoa-telefone>
        </p-tabPanel>
        <p-tabPanel header="Endereços Eletrônicos" leftIcon="pi pi-file-export" >
          <app-pessoa-endereco-eletronico [pessoa]="pessoa">
          </app-pessoa-endereco-eletronico>
        </p-tabPanel>
      </p-tabView>
      <ng-template pTemplate="footer">
        <div class="p-col-12">
          <button pButton appBotaoVoltar class="p-button-primary p-lg-12" label="Voltar"></button>
        </div>
      </ng-template>
    </p-card>
  </div>
</div>
